import { Control } from "react-hook-form";

import { FormConfirmDialog } from "@/components/FormConfirmDialog";

import { MemberCardEditor, MemberCardEditorState } from "./MemberCardEditor";

export function MemberCardEditorDialog({
  open,
  title,
  onClose,
  onSubmit,
  loading,
  control,
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  onSubmit: () => void | PromiseLike<void>;
  loading: boolean;
  control: Control<MemberCardEditorState>;
}) {
  return (
    <FormConfirmDialog
      control={control}
      title={title}
      loading={loading}
      open={open}
      onClose={onClose}
      onConfirm={onSubmit}
    >
      <MemberCardEditor control={control} />
    </FormConfirmDialog>
  );
}
